<template>
    <div class="container-fluid">
        <Breadcrumb title="Links" button-url="linkCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by Group"
                                            v-model="groupSearch"
                                            :multiple="false"
                                            :options="groupList"
                                            :load-options="loadGroupList"
                                            :disabled="Boolean(this.groupId)"
                                />
                            </div>
                            <input v-model="urlSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by URL">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="linkList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('id')">
                                                    <span role='button'>ID</span>
                                                </th>
                                                <th @click="tableOrdering('group.name')">
                                                    <span role='button'>Group</span>
                                                </th>
                                                <th @click="tableOrdering('url')">
                                                    <span role='button'>URL</span>
                                                </th>
                                                <th v-if="isAdmin">Owner</th>
                                                <th>Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(link, index) in linkList" :key="index">
                                                <td class="align-middle">{{link.id}}</td>
                                                <td class="align-middle">{{link.group.name}}</td>
                                                <td class="align-middle">{{link.url}}</td>
                                                <td class="align-middle" v-if="isAdmin">{{link.user.username}}</td>
                                                <td class="align-middle">
                                                    <router-link
                                                            :to="{ name: 'linkEdit', params: { id: link.id }}"
                                                            class="btn btn-sm btn-info m-r-10">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </router-link>
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                            @click="deleteLink(link.id)">
                                                        <i class="fa fa-minus-circle"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate v-if="pageCount > 1"
                                              v-model="page"
                                              :page-count="pageCount"
                                              :page-range="3"
                                              :margin-pages="2"
                                              :click-handler="getItems"
                                              :prev-text="'Prev'"
                                              :next-text="'Next'"
                                              :container-class="'pagination justify-content-center'"
                                              :page-class="'page-item'"
                                              :page-link-class="'page-link'"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import LinkService from '../services/LinkService';
    import LinkGroupService from '../services/LinkGroupService';
    import UserService from '../services/UserService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'Links',
        props: ['groupId'],
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                isAdmin: this.$store.getters.isAdmin,
                orderField: 'id',
                orderDirection: 'asc',
                linkList: [],
                groupSearch: null,
                urlSearch: null,
                userSearch: null,
                userList: null,
                groupList: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                LinkService.getLinks(
                    pageNum,
                    this.perPage,
                    this.orderField,
                    this.orderDirection,
                    this.groupId ? this.groupId : this.groupSearch,
                    this.userSearch,
                    this.urlSearch
                ).then(response => {
                    this.linkList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            tableOrdering(field) {
                if (this.orderField === field) {
                    this.orderDirection = (this.orderDirection === 'asc') ? 'desc' : 'asc';
                } else {
                    this.orderField = field;
                    this.orderDirection = 'asc';
                }
                this.getItems(this.page = 1);
            },
            deleteLink(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return LinkService.deleteLink(id).then((response) => {
                            if (response.status === 204) {
                                let linkIndex = this.linkList.findIndex(obj => obj.id === id);
                                this.linkList.splice(linkIndex, 1);
                                this.totalItems--;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Link has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadGroupList({callback}) {
                LinkGroupService.getGroupSelect().then(response => {
                    this.groupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback(this.groupSearch = this.groupId);
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>